import React from 'react';
import { Text } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import { Form } from '../../../app-components/form/Form';
import { getUser, invoke } from '../../../AppServices';
import { autoSuggestOptionsInput } from '../../../autoSuggestions';
import { modifyDateView } from '../../../Lib/helpers';

const checkField = (d) => (
  <Text
    style={{
      fontFamily: 'Mulish-Regular',
      letterSpacing: '0em',
      fontSize: 20,
      textAlign: 'left',
      color: 'black',
    }}
  >
    {modifyDateView(d)}
  </Text>
);

export const BuyPlanScreen = (props) => {
  const { navigation } = props;
  const start = new Date();
  const end = new Date();
  end.setDate(end.getDate() + 30);
  return (
    <Form
      type="standard"
      validations={{
        price: ({ data }) => (data.price < 0 ? 'Invalid value' : ''),
      }}
      onSubmit={async ({ data }) => {
        const fromBack = await invoke({
          id: 'canDealerBuy',
          paramValue: { dealerId: navigation?.state?.params?.item?._id },
        });

        if (Object.keys(fromBack.result).length !== 0) {
          Toast.show(fromBack.result);
        } else {
          const toPass = {};
          toPass.expire = end;
          toPass.paymentMode = data.paymentMode;

          const dealerId = navigation?.state?.params?.item?._id;

          if (data.paymentMode === 'CASH') {
            await invoke({
              id: 'handleDealerSubscriptionPlanBuy',
              paramValue: { data: toPass, dealerId },
            });

            const history = {
              dealerId: { _id: dealerId },
              transactionId: 'N.A.',
              price: data.price,
              transactionDateTime: new Date(),
              transactionMode: 'CASH',
              purchasedByName: getUser().username,
            };

            await invoke({
              id: 'addSubscriptionHistoryRecord',
              paramValue: { data: history },
            });
            Toast.show({
              message: 'Success',
              description: 'Plan Successfully purchased',
              type: 'success',
              position: 'top',
              direction: 'left',
            });
            navigation.pop();
          } else {
            navigation.push({
              view: 'payment',
              params: {
                ...data,
                dealerId,
                dealerUsername: navigation?.state?.params?.item?.username
                  ? navigation?.state?.params?.item?.username
                  : 'no-username',
              },
              modal: true,
              modalProps: {
                width: 600,
                heiht: 400,
              },
            });
          }
        }
      }}
      mandatory={{ paymentMode: 1, price: 1 }}
      fieldContainer="topLabel"
      lg={{
        formGroups: [
          {
            columnsPerRow: 2,
            fieldVariant: 'filled',
            groups: [
              {
                columns: [
                  {
                    label: 'Start Date',
                    render: () => checkField(start),
                  },
                  {
                    label: 'Expiry Date',
                    render: () => checkField(end),
                  },
                  {
                    type: 'number',
                    field: 'price',
                    label: 'Price($)',
                    editable: true,
                    mandatory: true,
                  },
                  autoSuggestOptionsInput({
                    label: 'Payment Mode',
                    field: 'paymentMode',
                    suggestionField: 'label',
                    valueField: 'label',
                    options: ['CC', 'CASH'],
                    keyField: 'label',
                    editable: true,
                    mandatory: true,
                  }),
                ],
              },
            ],
          },
        ],
      }}
      {...props}
    />
  );
};
